export default __webpack_public_path__ + "2016 Cavity-controlled chemistry in molecular ensembles.pdf";